import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-form-fees" }
const _hoisted_2 = { class: "order-form-fees__label" }
const _hoisted_3 = {
  key: 1,
  class: "order-form-fees__number"
}
const _hoisted_4 = { class: "order-form-fees__label" }
const _hoisted_5 = {
  key: 3,
  class: "order-form-fees__number"
}

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import BigNumber from '@exchange/helpers/bignumber';
import { OrderSide, OrderType } from '@exchange/libs/order/shared-model/src/lib/order-essentials';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';

interface AmountToReceive {
  value: BigNumber;
  code: string;
  precision: number;
}

interface SideFee {
  value: BigNumber;
  code: string;
  precision: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderFormFees',
  props: {
  feeValue: { type: Number, required: false },
  side: { type: String as PropType<OrderSide>, required: true },
  sideAmount: { type: Object as PropType<AmountToReceive>, required: false },
  sideFee: { type: Object as PropType<SideFee>, required: false },
  type: { type: String as PropType<OrderType>, required: true },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const currentSideFeeDefined = computed(() => Boolean(props.sideFee));

const feeLabel = computed(() => {
  let feeValueString = t('fundamentals.emptyValues.default');

  if (props.feeValue !== undefined) {
    feeValueString = props.feeValue.toFixed(CONSTANTS.PRECISION.DEFAULT_FEE);
  }

  return t('modules.orderForm.fee', {
    feeValue: feeValueString,
  });
});

const feeAmount = computed(() => ({
  number: props.sideFee?.value,
  suffix: props.sideFee?.code,
  precision: props.sideFee?.precision,
}));

const estimationPrefix = computed(() => (props.type.toUpperCase() === OrderType.MARKET && props.side === OrderSide.SELL ? '~ ' : ''));

return (_ctx: any,_cache: any) => {
  const _component_ot_number_display = _resolveComponent("ot-number-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(feeLabel.value), 1)
    ]),
    (currentSideFeeDefined.value)
      ? (_openBlock(), _createBlock(_component_ot_number_display, {
          key: 0,
          class: "order-form-fees__number user-select",
          grouping: true,
          number: feeAmount.value.number,
          precision: feeAmount.value.precision,
          prefix: estimationPrefix.value,
          suffix: feeAmount.value.suffix
        }, null, 8, ["number", "precision", "prefix", "suffix"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('fundamentals.emptyValues.default')), 1)),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('modules.orderForm.amountToReceive')), 1),
    (currentSideFeeDefined.value)
      ? (_openBlock(), _createBlock(_component_ot_number_display, {
          key: 2,
          class: "order-form-fees__number user-select",
          grouping: true,
          number: __props.sideAmount && __props.sideAmount.value,
          precision: __props.sideAmount && __props.sideAmount.precision,
          prefix: estimationPrefix.value,
          suffix: __props.sideAmount && __props.sideAmount.code
        }, null, 8, ["number", "precision", "prefix", "suffix"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('fundamentals.emptyValues.default')), 1))
  ]))
}
}

})